import React from 'react';
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { useTranslation } from 'react-i18next';
import {
  LOCALE_STORAGE_KEY,
  getLocale,
  locales,
  normalizeLanguage,
} from '../i18n/locales';

const LocaleSwitcher = ({ fullWidth = false }) => {
  const { i18n, t } = useTranslation();
  const currentLanguage = normalizeLanguage(i18n.resolvedLanguage || i18n.language);
  const currentLocale = getLocale(currentLanguage);

  const handleLanguageChange = (event) => {
    const language = event.target.value;

    window.localStorage.setItem(LOCALE_STORAGE_KEY, language);
    i18n.changeLanguage(language);
  };

  return (
    <Box
      component="nav"
      aria-label={t('locale.selectorLabel')}
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        minWidth: 0,
        width: fullWidth ? '100%' : 'auto',
      }}
    >
      <FormControl
        size="small"
        sx={{
          minWidth: fullWidth ? 0 : { xs: 92, sm: 132 },
          width: fullWidth ? '100%' : 'auto',
        }}
      >
        <Select
          value={currentLocale.code}
          onChange={handleLanguageChange}
          displayEmpty
          aria-label={t('locale.selectorLabel')}
          inputProps={{ 'aria-label': t('locale.selectorLabel') }}
          renderValue={(selected) => {
            const locale = getLocale(selected);

            return (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                <LanguageIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                <Typography
                  component="span"
                  sx={{ fontWeight: 800, fontSize: { xs: '0.76rem', sm: '0.82rem' } }}
                >
                  {locale.shortLabel}
                </Typography>
              </Box>
            );
          }}
          sx={{
            borderRadius: 999,
            bgcolor: 'rgba(255, 250, 240, 0.76)',
            width: fullWidth ? '100%' : 'auto',
            '& .MuiSelect-select': {
              py: 0.75,
              pr: '32px !important',
            },
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                mt: 1,
                minWidth: 188,
                border: '1px solid',
                borderColor: 'divider',
              },
            },
          }}
        >
          {locales.map((locale) => (
            <MenuItem key={locale.code} value={locale.code} dir={locale.dir}>
              <Box sx={{ minWidth: 0 }}>
                <Typography sx={{ fontWeight: 700 }}>{locale.label}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {locale.shortLabel}
                </Typography>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default LocaleSwitcher;
